import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import store from './store/store';
import { authProvider } from './authProvider';
import { EventType, InteractionType } from '@azure/msal-browser';
import { MsalProvider, MsalAuthenticationTemplate } from '@azure/msal-react';
import Env from './Env';
import setupMockservice from './_mockservice/setup';
import SiteLoader from './components/site-loader/site-loader';
import queryString from 'query-string';
const b2cOptions = Env.getB2COptions();

const authRequest = {
  scopes: [b2cOptions.appId],
  ...(queryString.parse(window.location.search)?.id_token_hint && {
    extraQueryParameters: {
      id_token_hint: queryString.parse(window.location.search)?.id_token_hint,
    },
  }),
};

if (Env.getMockSwitch() === 'on') {
  setupMockservice();
}

const root = createRoot(document.getElementById('root'));
root.render(
  <MsalProvider instance={authProvider}>
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      loadingComponent={SiteLoader}
    >
      <Provider store={store}>
        <App />
      </Provider>
    </MsalAuthenticationTemplate>
  </MsalProvider>
);

//TODO: Call to remove the event callback on unload
authProvider.addEventCallback((message) => {
  if (message.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
    console.log('Auth Error login failure: ', message);
    // if (message.error instanceof AuthError) {
    //   // Do something with the error
    //   console.log('AuthError');
    // }
  }
  if (message.eventType === EventType.LOGIN_FAILURE) {
    //Forgot password flow: AADB2C90118
    if (message.error && message.error.errorMessage.indexOf('AADB2C90118') > -1) {
      const forgotPasswordRequest = {
        authority: Env.getForgotPasswordPolicyUrl(),
      };
      if (message.interactionType === InteractionType.Redirect) {
        authProvider.loginRedirect(forgotPasswordRequest);
      }
      return; // Prevent further handling
    }
    //Cancel forgot flow or Reset password flow: AADB2C90091
    if (message.error && message.error.errorMessage.indexOf('AADB2C90091') > -1) {
      const signInRequest = {
        authority: Env.getLoginPolicyUrl(),
      };
      if (message.interactionType === InteractionType.Redirect) {
        authProvider.loginRedirect(signInRequest);
      }
      return; // Prevent further handling
    }
    // Only log other errors - do not trigger another redirect to avoid infinite loops
    console.error('Login failure:', message.error);
  }
});

// Unregister service worker and clean up any existing registrations
serviceWorker.unregister();

// Clean up existing service workers in users' browsers
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
}
